import classNames from 'classnames'

import { Icon } from '@/Atomic/Atoms/Icon'
import { getAvatarInitialsColorClass } from '@/utils/avatarColor'

import './AvatarProfile.scss'

export type AvatarSize = 'sm' | 'md' | 'lg'

interface AvatarProfileProps {
  src?: string
  icon?: string
  size?: AvatarSize
  initials?: string
  /**
   * Stable value used to choose the initials background color. Required when
   * `initials` is provided.
   *
   * Pass the entity ID so the same entity keeps the same color across renders.
   */
  initialsColorSeed?: string
  className?: string
}

export const AvatarProfile: React.FC<AvatarProfileProps> = ({
  src,
  icon,
  size = 'md',
  initials,
  initialsColorSeed,
  className,
}) => {
  const showIcon = !src && !initials && !!icon
  const colorClass =
    !src && initials && initialsColorSeed
      ? getAvatarInitialsColorClass(initialsColorSeed)
      : undefined

  return (
    <div
      className={classNames(
        'profile-dot',
        `profile-dot--${size}`,
        colorClass,
        className,
        {
          'profile-dot--icon': showIcon,
        },
      )}
    >
      {src ? (
        <img referrerPolicy="no-referrer" src={src} alt="" />
      ) : initials ? (
        <span>{initials}</span>
      ) : icon ? (
        <Icon icon={icon} />
      ) : (
        <span>NA</span>
      )}
    </div>
  )
}
